import { render, staticRenderFns } from "./outboundapprove.vue?vue&type=template&id=0a3e971a&scoped=true"
import script from "./outboundapprove.vue?vue&type=script&lang=js"
export * from "./outboundapprove.vue?vue&type=script&lang=js"
import style0 from "./outboundapprove.vue?vue&type=style&index=0&id=0a3e971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e971a",
  null
  
)

export default component.exports